import {useState} from 'react';
import moment from 'moment';
import {isEmpty} from 'lodash';
import AgyleButton from '../../../../../components/ui/buttons/agyleButton';
import AgyleLoadingSpinner from '../../../../../components/other/agyleLoadingSpinner';
import AppointmentDetails from './appointmentDetails';
import {Grid, Typography} from '@mui/material'
import usePatientAppointments from './usePatientAppointments';

export default function PatientScheduledAppointmentsList({ patient }) {
    const [appointmentList, appointmentsLoading] = usePatientAppointments({ hospitalNumber: patient?.patient?.hospitalNumber });

    const [selectedAppointment, setSelectedAppointment] = useState(null);

    return <Grid container alignContent='flex-start' gap={1}>
        {appointmentsLoading && <AgyleLoadingSpinner label="Loading patient's appointments..." />}

        {!appointmentsLoading ?
            !isEmpty(appointmentList) ? (
                <>
                    <Typography variant='body1' fontWeight={600}>Patient's appointments:</Typography>

                    {appointmentList.map((appointmentSlot, slotIdx) => {
                        return (
                            <Grid key={appointmentSlot?.__id} item xs={12} style={{maxWidth: 250}}>
                                <AgyleButton
                                    width="100%"
                                    variant="outlined"
                                    onClick={() => setSelectedAppointment(appointmentSlot)}
                                >
                                    {moment(appointmentSlot?.startDate).format('DD-MM-YYYY hh:mm A')}
                                </AgyleButton>
                            </Grid>
                        );
                    })}
                </>
                ) : "No appointments found for selected patient" :
            null
        }

        {selectedAppointment && (
            <AppointmentDetails
                appointment={selectedAppointment}
                onClose={() => setSelectedAppointment(null)}
            />
        )}
    </Grid>
}